class TradeProgramForm extends window.ProfessionalsMainForm {
  static EMBED_ID = 'app-embed-container-1100242';

  static FORM_ID = '1100242';

  static STEPS = [
    {
      label: 'Initial Information',
      startsAt: 'field-first_name',
    },
    {
      label: 'Application',
      startsAt: 'field-custom#business_name_1',
    },
  ];

  static FULL_WIDTH_FIELDS = [
    'field-custom#business_name_1',
    'field-custom#business_id_resale_certificate_1',
    'field-custom#business_address_1',
    'field-custom#business_address_2_optional',
    'field-customer_fields#country_south_america',
    'field-custom#business_website',
  ];

  static UPLOAD_HELP = {
    items: [
      'A valid business license as an Interior Designer, Architect, or Commercial Developer.',
      'Valid membership to a major design organization (e.g. ASID, IIDA, NKBA, IDC).',
      'Interior Design certification (e.g. NCIDQ, CCIDC).',
    ],
    footnote: "Please add your resale license if you'd like to receive tax-free checkout.",
  };

  static SUCCESS = {
    heading: 'Thank you for your application !',
    intro: [
      'Your application to the Audo Copenhagen Trade Program has been received.',
      'Our team will review your submission and get back to you within 3–5 business days.',
    ],
    steps: [
      {
        title: 'Application review',
        text: 'Our team will verify your credentials and business information.',
      },
      {
        title: 'Account activation',
        text: 'Once approved, you will receive an email with your login details and exclusive Trade discount.',
      },
      {
        title: 'Start shopping',
        text: 'Access your Trade pricing, request quotes, and book showroom appointments.',
      },
    ],
    contact: { label: 'Questions ? Contact us at', email: 'us.trade@audocph.com' },
    cta: { label: 'Explore the collection', href: '/collections/all' },
  };

  constructor(options = {}) {
    super({
      name: 'trade-program',
      steps: TradeProgramForm.STEPS,
      fullWidthFields: TradeProgramForm.FULL_WIDTH_FIELDS,
      uploadHelp: TradeProgramForm.UPLOAD_HELP,
      startedEvent: 'Started Trade Application',
      completedEvent: 'Completed Trade Application',
      successContent: TradeProgramForm.SUCCESS,
      headingAccent: 'Trade Program',
      nextLabel: 'Next step',
      backLabel: 'Back',
      tabsLabel: 'Trade program application steps',
      ...options,
    });
  }

  static boot() {
    const tag = document.getElementById('trade-program-form-js');
    const urlParam = 'open_signup';

    if (!TradeProgramForm.shouldBoot({ trigger: 'trade-program', urlParam })) return false;

    const formId = (tag && tag.dataset.formId) || TradeProgramForm.FORM_ID;
    const embedId =
      formId === TradeProgramForm.FORM_ID ? TradeProgramForm.EMBED_ID : `app-embed-container-${formId}`;

    const form = new TradeProgramForm({
      embedId,
      formId,
      stylesUrl: tag ? tag.dataset.styles : null,
      urlParam,
      partialCapture: tag ? tag.dataset.partialCapture === 'true' : false,
      debug: tag ? tag.dataset.debug === 'true' : false,
    });

    if (form.debug || (window.Shopify && window.Shopify.designMode)) {
      window.tradeProgramForm = form;
    }

    return form.init();
  }
}

TradeProgramForm.boot();
